import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.75 11.25V1.875h1.875v9.375zM22.5 11.25V1.875h1.875v9.375zM26.25 11.25V1.875h1.875v9.375z" }, null, -1),
    _createElementVNode("path", {
      "stroke-width": "1.3",
      d: "M15 18.75A3.67 3.67 0 0 1 11.25 15 3.67 3.67 0 0 1 15 11.25V9.375A5.625 5.625 0 1 0 20.625 15H18.75A3.67 3.67 0 0 1 15 18.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-width": "1.3",
      d: "m27.087 17.3-2.62-2.3-1.236 1.41 2.618 2.299-2.213 3.832-3.213-1.087a8.5 8.5 0 0 1-2.544 1.467l-.667 3.329h-4.424l-.666-3.329a8.5 8.5 0 0 1-2.527-1.473l-3.23 1.093-2.213-3.832 2.554-2.246a8.4 8.4 0 0 1-.007-2.932l-2.548-2.24L6.364 7.46l3.213 1.087a8.5 8.5 0 0 1 2.544-1.467l.666-3.329H15V1.875h-2.213a1.875 1.875 0 0 0-1.838 1.507l-.472 2.362q-.647.31-1.244.706l-2.269-.767a1.87 1.87 0 0 0-2.224.838l-2.213 3.833a1.875 1.875 0 0 0 .386 2.346l1.81 1.59c-.016.236-.035.47-.035.71q0 .362.026.718L2.913 17.3a1.875 1.875 0 0 0-.386 2.346L4.74 23.48a1.87 1.87 0 0 0 2.224.838l2.282-.771q.59.398 1.23.71l.473 2.362a1.876 1.876 0 0 0 1.838 1.507h4.425a1.875 1.875 0 0 0 1.839-1.507l.472-2.362q.646-.31 1.244-.706l2.268.767a1.87 1.87 0 0 0 2.225-.838l2.213-3.833a1.875 1.875 0 0 0-.386-2.346Z"
    }, null, -1)
  ])))
}
export default { render: render }